'use strict';

import {findAll, register} from '../../../JavaScript/Utils';

const SplitBoxes = $el => {
    const $headlines = findAll('[data-nezzo-equal-height-headline] > h3:first-child', $el);
    const maxHeadlineHeight = Math.max.apply(null, $headlines.map(($headline) => {
        return $headline.offsetHeight;
    }))

    $headlines.forEach(($headline) => {
        $headline.style.height = maxHeadlineHeight + 'px';
    });
};

register('SplitBoxes', SplitBoxes);
